module.exports = __webpack_public_path__ + "top_page/industry-work-457e71391b3a4ad09b19ae55e89756ea.svg";